module.exports = __webpack_public_path__ + "static/avatar-93744f7c6b82229d451181b50bb41104.jpg";